import axiosInstance from '../axios'
import { withTimeout } from './pat-timeout'

export function getSaleTypesEligibility(vehicleList) {
    const validVehicleList = (vehicleList || []).filter(v => v && v.vin)
    if (validVehicleList.length === 0) {
        return Promise.resolve({ data: [] })
    }

    return withTimeout(
        axiosInstance.post('/vehicle/saletypes-eligibility', {
            vehicleList: validVehicleList
        })
    )
}

/**
 * Extracts a user-facing message from a failed sale type eligibility request (4xx/5xx/network/timeout),
 * so the error banner can show something more specific than a generic "Failed to load." when available.
 */
export function getPatErrorMessage(ex) {
    return ex?.response?.data?.error?.message
        || ex?.response?.data?.message
        || ex?.message
        || null
}
